import Reveal from "@/components/Reveal";

export default function Section({ eyebrow, title, lede, dark = false, className = "" }) {
  return (
    <Reveal className={`max-w-3xl ${className}`}>
      {eyebrow && (
        <p className={dark ? "eyebrow-light" : "eyebrow"} data-testid="section-eyebrow">{eyebrow}</p>
      )}
      <h2 className={`mt-4 font-serif text-3xl sm:text-4xl lg:text-[2.75rem] leading-tight tracking-tight ${dark ? "text-ivory" : "text-navy-900"}`}>
        {title}
      </h2>
      {lede && (
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>
          {lede}
        </p>
      )}
    </Reveal>
  );
}
